"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShortcutOverlay = exports.getDestination = exports.saveShortcuts = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var folderActions = require("@caddigital/sok-reducers/lib/actions/project/home");
var avatars_1 = require("components/Avatar/avatars");
var FolderTree_1 = require("components/FolderTree");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var Icon_1 = require("components/Icon");
require("./shortcutOverlay.scss");
var mapStateToProps = function (state) {
    return {
        home: state.project.currentProject,
        folderContent: state.project.currentProject.folderContent,
        folderTreeOverlayToggled: state.project.currentProject.folderTreeOverlayToggled
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    changeExpand: function (expand, folder) {
        return dispatch(folderActions.FolderTreeActions.copyChangeExpand(expand, folder));
    },
    selectItem: function (folder, value) {
        dispatch(folderActions.FolderTreeActions.selectFile(folder, value));
    },
    getContent: function (parent) {
        return dispatch(folderActions.FolderTreeActions.fetchTree(parent, ['FOLDER'], 'MINIMAL'));
    },
    closeOverlay: function () {
        dispatch(folderActions.FolderTreeActions.copyFilesToggleOverlay('MOVE'));
        dispatch(folderActions.FolderTreeActions.copyFilesReset());
    },
    saveShortcuts: function (folders, projectId) {
        dispatch(folderActions.addShortcutsRequest(folders, projectId));
        dispatch(folderActions.FolderTreeActions.copyFilesReset());
    }
}); };
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('CreateFolderShortcut'), (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), recompose_1.pure);
var saveShortcuts = function (props) { return function () {
    if (!props.folderContent.data.tree ||
        !props.folderContent.data.tree
            .getNodes()
            .find(function (x) { return x.getSelected() === true; })) {
        return;
    }
    props.saveShortcuts(props.folderContent.data.tree
        .getNodes()
        .filter(function (f) { return f.getSelected() === true; })
        .map(function (x) { return x.getValue().id; }), props.currentProject.id);
}; };
exports.saveShortcuts = saveShortcuts;
var getDestination = function (folders, selected) {
    var destination = folders.find(function (x) {
        return x.uuid === selected;
    });
    return destination ? destination.name : '';
};
exports.getDestination = getDestination;
var shortcutExists = function (shortcuts, selected) {
    var sel = selected.reduce(function (prev, curr) {
        prev[curr.id] = curr;
        return prev;
    }, {});
    return shortcuts.filter(function (x) { return sel[x.id]; }).length > 0;
};
exports.ShortcutOverlay = enhance(function (props) { return (React.createElement(sok_ui_1.Overlay, { isOpen: props.folderContent.mode !== 'CLOSED', onClose: function () { return props.closeOverlay(); } },
    React.createElement(sok_ui_1.SideMenu, { className: 'sok-folder-shortcut-details', isOpen: props.folderContent.mode !== 'CLOSED', docked: false, orientation: 'right' },
        React.createElement(sok_ui_1.Header, { onClose: function () { return props.closeOverlay(); } }, (0, translation_1.getLocalization)('userfront/project/FolderShortcutOverlay/add')),
        React.createElement(sok_ui_1.Container, null,
            props.home.folderContent.data.status === 'FAILED' ? (React.createElement("div", { className: 'files-view-folder-permisssion-denied' },
                React.createElement("span", null,
                    React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_19'), width: 200, height: 200 })),
                React.createElement("span", null, (0, translation_1.getLocalization)('shortcuts/denied/dear')),
                React.createElement("span", null, (0, translation_1.getLocalization)('shortcuts/denied/folder')),
                React.createElement("span", null,
                    (0, translation_1.getLocalization)('shortcuts/denied/permissionsFrom'),
                    ' ',
                    React.createElement("b", null,
                        " ",
                        (0, translation_1.getLocalization)('shortcuts/denied/admins')),
                    ' ',
                    (0, translation_1.getLocalization)('shortcuts/denied/view')))) : (props.home.folderContent.data.tree && (React.createElement(FolderTree_1.default, { perm: props.currentProject.perm, parentIdentifier: props.currentProject.rootFolderIdentifier, tree: props.home.folderContent.data.tree, selectItem: props.selectItem, changeExpand: props.changeExpand, getContent: props.getContent }))),
            React.createElement("div", { className: 'loading-spinner' }, props.home.folderContent.data.status === 'FETCHING' &&
                !props.home.folderContent.data.tree && React.createElement(sok_ui_1.LoadingSpinner, null))),
        React.createElement(sok_ui_1.Footer, null,
            props.home.shortcutStatus === 'SAVING' ? (React.createElement(sok_ui_1.Button, { color: "dark-green", text: React.createElement(Icon_1.Icon, { className: 'fa-spinner fa-spin' }) })) : props.home.shortcutStatus === 'SAVED' ? (React.createElement(sok_ui_1.Button, { color: "dark-green", text: "Saved" })) : props.home.shortcutStatus === 'FAILED' ? (React.createElement(sok_ui_1.Button, { color: "red", text: "Error" })) : (React.createElement(sok_ui_1.Button, { color: 'green', disabled: shortcutExists(props.home.shortcuts, props.folderContent.data.tree
                    ? props.folderContent.data.tree
                        .getNodes()
                        .filter(function (x) { return x.getSelected() === true; })
                        .map(function (x) { return x.getValue(); })
                    : []), onClick: (0, exports.saveShortcuts)(props), text: (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/save') })),
            React.createElement(sok_ui_1.Button, { color: 'dark-gray', onClick: function () { return props.closeOverlay(); }, text: (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/cancel') }))))); });
